import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import CTAButton from '../CTAButton';

const ServiceHero = ({ data, onPrimaryClick, onSecondaryClick }) => {
    return (
        <section className="relative min-h-[80vh] lg:min-h-[90vh] bg-[#01014C] overflow-hidden flex items-center">
            
            {/* Full-screen background image */}
            {data.heroImage && (
                <motion.div 
                    initial={{ scale: 1.05 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                    className="absolute inset-0 w-full h-full pointer-events-none"
                    style={{ 
                        backgroundImage: `url('${typeof data.heroImage === 'object' ? data.heroImage.default : data.heroImage}')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                />
            )}
            
            {/* Gradient Overlay for legibility - Centered overlay */}
            <div className="absolute inset-0 bg-[#01014C]/75 z-0 pointer-events-none" />

            <div className="container mx-auto px-6 relative z-10 py-20">
                <div className="max-w-4xl mx-auto text-center space-y-6">
                    <motion.div 
                        initial={{ opacity: 0, y: -20 }} 
                        animate={{ opacity: 1, y: 0 }} 
                        className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-cyan-300 text-xs font-bold uppercase tracking-[0.2em] mb-2 backdrop-blur-md justify-center"
                    >
                        <Sparkles size={14} className="animate-pulse" /> AI-Powered Systems
                    </motion.div>
                    
                    <motion.h1 
                        initial={{ opacity: 0, y: 20 }} 
                        animate={{ opacity: 1, y: 0 }} 
                        transition={{ delay: 0.2 }} 
                        className="text-3xl md:text-5xl lg:text-6xl font-bold text-white syne leading-tight mb-4"
                    >
                        {data.title}
                    </motion.h1>
                    
                    {data.subtitle && (
                        <motion.h2 
                            initial={{ opacity: 0, y: 20 }} 
                            animate={{ opacity: 1, y: 0 }} 
                            transition={{ delay: 0.3 }} 
                            className="text-lg md:text-xl lg:text-2xl font-bold text-blue-300 mb-4 max-w-3xl mx-auto leading-relaxed"
                        >
                            {data.subtitle}
                        </motion.h2>
                    )}
                    
                    <motion.p 
                        initial={{ opacity: 0, y: 20 }} 
                        animate={{ opacity: 1, y: 0 }} 
                        transition={{ delay: 0.4 }} 
                        className="text-blue-100/70 text-sm md:text-base lg:text-lg mb-8 leading-relaxed font-light max-w-3xl mx-auto"
                    >
                        {data.description}
                    </motion.p>
                    
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }} 
                        animate={{ opacity: 1, y: 0 }} 
                        transition={{ delay: 0.5 }} 
                        className="flex flex-wrap justify-center gap-4 pt-2"
                    >
                        <CTAButton 
                            text={data.primaryCTA}
                            onClick={onPrimaryClick}
                            type="primary"
                        />
                        {data.secondaryCTA && (
                            <CTAButton 
                                text={data.secondaryCTA}
                                onClick={onSecondaryClick}
                                type="outline-light"
                            />
                        )}
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default ServiceHero;